import { useEffect, useRef } from 'react';
import { Intercom, update } from '@intercom/messenger-js-sdk';
import { useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router-dom';
import { IGNORE_SUPPORT_CHAT_PATHS } from 'consts/paths';
import { getUser } from 'store/user/selectors';
import { newApiInstance } from 'functions/request';
import CConsole from 'functions/CConsole';

const useInitIntercom = () => {
  const isInitialized = useRef(false);
  const { pathname } = useLocation();
  const user = useSelector(getUser);
  const ignoreSupportChat = IGNORE_SUPPORT_CHAT_PATHS.some(path =>
    matchPath(pathname, { path, exact: true, strict: false }),
  );
  const name = user.name || user.first_name;

  useEffect(() => {
    const init = async () => {
      const { data } = await newApiInstance.get('/users/intercom_token');

      Intercom({
        app_id: process.env.REACT_APP_INTERCOM_ID,
        intercom_user_jwt: data.data.token,
        user_id: user.id,
        name,
        email: user.email,
        created_at: user.created_at ? Math.round(new Date(user.created_at).getTime() / 1000) : undefined,
      });

      isInitialized.current = true;
    };

    if (isInitialized.current || !user.id || !process.env.REACT_APP_INTERCOM_ID || ignoreSupportChat) {
      return;
    }

    init().catch(CConsole.error);
  }, [user.id, ignoreSupportChat]);

  useEffect(() => {
    if (!isInitialized.current) return;

    // hide already shown button
    update({
      hide_default_launcher: ignoreSupportChat,
    });
  }, [ignoreSupportChat]);

  useEffect(() => {
    if (!isInitialized.current) return;

    // update user on guest signup or user change
    update({
      user_id: user.id,
      name,
      email: user.email,
    });
  }, [user.id, name, user.email]);
};

export default useInitIntercom;
